import { action } from 'mobx';
import { FacilityInventoryCountModalEditForm } from 'application/facility-inventory/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { FacilityInventoryCountHeaderService } from 'application/facility-inventory/services';

@applicationContext
class FacilityInventoryCountModalEditViewStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const id = componentProps && componentProps.modalParams && componentProps.modalParams.data.id;
        const createInventory = componentProps && componentProps.modalParams && componentProps.modalParams.data.createInventory;
        const service = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'facility-inventory',
            id: id,
            Form: FacilityInventoryCountModalEditForm,
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        createInventory(resource.countDate);
                    }
                }
            },
            FormClass: FacilityInventoryCountModalEditForm,
        });

        this.service = service;
        this.modalParams = componentProps.modalParams;
        this.facilityOrder = componentProps && componentProps.modalParams && componentProps.modalParams.data.facilityOrder;
        this.title = componentProps && componentProps.modalParams && componentProps.modalParams.data.title;
    }

    @action
    async initialize() {
        if (this.isEdit) {
            await this.getResource(this.id);
        } else {
            this.form.clear();
            this.form.$("countDate").value = new Date();
        }
    }

    @action.bound
    async createResource(resource) {
        if(this.facilityOrder && (new Date(this.facilityOrder.nextDeliveryDate) < new Date(resource.countDate))){
            this.rootStore.notificationStore.error("Count Date must be before the Delivery Date.");
            return;
        }
        this.form.setFieldsDisabled(true);
        try {

            await this.actions.create({
                ...resource
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();

            await setTimeout(() => this.notifySuccessCreate(this.name), 10);
        }
        catch (error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data : `An error ocurred`
            );
        }
    }
    
    @action.bound
    notifySuccessCreate(name) {
        this.rootStore.notificationStore.success('FACILITY_INVENTORY_COUNT.CREATE.SUCCESS', name);
    }

    @action.bound
    async updateResource(resource) {
        if(this.facilityOrder && (new Date(this.facilityOrder.nextDeliveryDate) < new Date(resource.countDate))){
            this.rootStore.notificationStore.error("Count Date must be before the Delivery Date.");
            return;
        }
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();

            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data : `An error ocurred`
            );
        }
    }

    @action.bound
    async saveResource(resource) {
        await this.service.create(resource);

        await this.onCreate();

        this.form.reset();
        this.form.update(resource);
        this.form.setFieldsDisabled(false);
        await setTimeout(() => this.notifySuccessCreate(), 10);
    }

}

export default FacilityInventoryCountModalEditViewStore;
